// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_zTf","cls2":"PaperClaimedToast-cls2_rQU PaperClaimedToast-cls1_zTf"};